import { render } from "./3d-hew.vue?vue&type=template&id=0f7e94a4&scoped=true"
import script from "./3d-hew.vue?vue&type=script&lang=js"
export * from "./3d-hew.vue?vue&type=script&lang=js"

import "./3d-hew.vue?vue&type=style&index=0&id=0f7e94a4&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7e94a4"]])

export default __exports__